import axios from 'axios';
import { API_URL } from '@/config';

export default {

  create(data) {
    return axios.post(`${API_URL}/member-create`, data);
  },

  delete(data) {
    return axios.post(`${API_URL}/member-delete`, data);
  },

  list() {
    return axios.get(`${API_URL}/members`);
  },

  read(id) {
    return axios.get(`${API_URL}/members/${id}`);
  },

  update(data) {
    return axios.post(`${API_URL}/member-edit`, data);
  },

  unlock(data) {
    return axios.post(`${API_URL}/member-unlock`, data);
  },

  export() {
    window.open(`${API_URL}/members/export?extension=csv`, '_blank');
  },

  ips() {
    return axios.get(`${API_URL}/member-ip`);
  },

  editMailNotif(data) {
    return axios.post(`${API_URL}/member-mail-notification`, data);
  },

  getMailNotif(data) {
    return axios.get(`${API_URL}/member-mail-notification`, data);
  },

  getZabbixEmailNotif(data) {
    return axios.get(`${API_URL}/member-zabbix-notification`, data);
  },

  editZabbixMailNotif(data) {
    return axios.post(`${API_URL}/member-zabbix-notification`, data);
  },
};
